import type { PropertiesVersion, TrackerOptions } from '@mathflat/data-tracking'
import { deviceType } from 'react-device-detect'

import { envUtils } from '../envUtils'

export const GLOBAL_PROPERTIES_VERSION: PropertiesVersion = 'v1.0@2025-10-15'
export const USER_PROPERTIES_VERSION: PropertiesVersion = 'v1.0@2025-10-15'

// 한도 위반 보고는 사용자 콘솔에 남기지 않고, MIXPANEL_DEBUG 를 켠 경우에만 패키지 기본값(console.error)으로 본다
const ignoreInvalidPayload = () => undefined

export const buildStudentTrackerOptions = (): TrackerOptions => {
  const token = import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN
  const debug = localStorage.getItem('MIXPANEL_DEBUG') === 'true'
  return {
    mixpanel: {
      token: token ?? '',
      config: {
        track_pageview: true,
        persistence: 'localStorage',
        cookie_name: 'version3',
        cross_subdomain_cookie: false,
        autocapture: {
          click: false,
          // `/` 는 화면 없이 항상 다른 경로로 넘기는 경로(router 맨 끝 catch-all loader 가 redirect)라 `/` 페이지뷰는 의미가 없다.
          // init 이 리다이렉트보다 먼저 끝나면 `/` 페이지뷰가 남지만, 라이브 데이터를 유지하려고 지금은 막지 않는다.
          // 막아야 하면 아래 한 줄을 넣는다 — 넘어간 뒤의 페이지뷰와 수기 이벤트는 그대로 나간다.
          // block_url_regexes: [/^https?:\/\/[^/]+\/?(?:[?#].*)?$/],
          pageview: 'url-with-path',
          scroll: true,
          submit: false,
          input: false,
          capture_text_content: false,
        },
        app_host: window.location.hostname,
        debug,
        batch_requests: envUtils.isLive,
        // 기본값을 opt-out 으로 두고, 프리미엄 학원 학생일 때만 명시적으로 opt-in 한다.
        opt_out_tracking_by_default: true,
        // 버저닝 이전에 객체째 등록하던 옛 super property 를 지운다. 지금 값은 academy_·student_·parent_ 접두 키라 겹치지 않는다
        loaded: (mixpanel) => {
          if (mixpanel.get_property('globalPropertiesVersion')) return
          mixpanel.unregister('academy')
          mixpanel.unregister('parent')
          mixpanel.unregister('student')
        },
      },
    },
    enabled: !!token,
    send: true,
    // 추적 대상(프리미엄 학원 학생)인지는 로그인 뒤 정해진다. 그 전 이벤트는 모아 뒀다가 opt-in 이면 보내고 opt-out 이면 버린다
    deferUntilConsent: true,
    context: {
      $device_type: deviceType,
      $user_agent: navigator.userAgent,
      releaseId: envUtils.releaseId,
    },
    onInvalid: debug ? undefined : ignoreInvalidPayload,
  }
}
